import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getListBuffet } from '~/apis/menu'

import request from '~/apis/request'
import { loadingStates } from '~/config/constant'
import { EXTERNAL_PARTNER } from '~/constants'
import { menuTemplate } from '~/constants/menu'
import { getInfoRestaurant, isBuffetMenu } from '~/utils'

const initialState = {
  data: [],
  loading: loadingStates.idle,
  error: {},
}

const convertBuffetFoodItems = (foodItem) => ({
  ...foodItem,
  price: 0,
  original_price: 0,
  is_buffet_item: true,
})

// Hàm xử lý dữ liệu, chuyển đổi data của buffet sao cho phù hợp với data menu
const convertDataCategoriesBuffet = (dataBuffet = []) => {
  return dataBuffet.map((categoryItem) => ({
    ...categoryItem,
    id: -categoryItem?.id || -1, // id của món ăn buffet để -id gốc tránh  duplicate.
    category_template: 'default',
    open_time_csv: categoryItem?.open_time_csv || '',
    food_items: categoryItem?.food_items?.map((foodItem) => convertBuffetFoodItems(foodItem)) || [],
    is_buffet_category: true,
  }))
}

export const fetchMenu = createAsyncThunk('menu/fetchMenu', async (id, { rejectWithValue }) => {
  try {
    const response = await request().get(`/restaurants/${id}/menu`)
    const { externalPartner, restaurantId, buffet_requests_time, extraFeatures } =
      getInfoRestaurant()

    const isBuffetMenuEnabled = isBuffetMenu(extraFeatures) // Kiểm tra xem nhà hàng có cài đặt buffet hay không

    // Nếu trong trường hợp là smaregi thì sẽ gọi thêm api buffet nữa để nối vào đầu mảng
    if (
      externalPartner === EXTERNAL_PARTNER.Smaregi ||
      (isBuffetMenuEnabled && buffet_requests_time) // trong trường hợp cài đặt buffet menu và có buffet_requests_time
    ) {
      const { data: dataBuffet, isSuccess } = await getListBuffet(restaurantId)
      if (isSuccess && dataBuffet?.length > 0) {
        const dataBuffetUpdated = convertDataCategoriesBuffet(dataBuffet)
        const dataMenuList = response.data?.data || []

        const indexCategoryVideo = dataMenuList.findIndex(
          (menu) => menu.category_template === menuTemplate.videoDish,
        )
        // Xử lý trong trường hợp có category video chèn data này lên đầu
        if (indexCategoryVideo >= 0) {
          const dataCategoryVideo = dataMenuList.splice(indexCategoryVideo, 1)

          return {
            data: dataCategoryVideo.concat(dataBuffetUpdated, dataMenuList),
          }
        }

        return {
          data: dataBuffetUpdated.concat(dataMenuList),
        }
      }
    }

    return response.data
  } catch (err) {
    if (!err.response) throw err
    const { status, data } = err.response
    return rejectWithValue({ status, data })
  }
})

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    resetMenu: () => initialState,
  },
  extraReducers: {
    [fetchMenu.pending]: (state) => {
      state.loading = loadingStates.pending
    },
    [fetchMenu.fulfilled]: (state, action) => {
      state.loading = loadingStates.success
      state.data = action.payload.data
    },
    [fetchMenu.rejected]: (state, action) => {
      state.loading = loadingStates.error
      state.error = action.payload
    },
  },
})

// Xử lý và filter theo thời gian setting của category
export const selectValuesMenu = (state) => {
  const dataMenu = state.menu.data
  if (!dataMenu)
    return {
      loading: state.menu.loading,
      data: [],
    }
  return {
    loading: state.menu.loading,
    data: dataMenu,
  }
}

export const { resetMenu } = menuSlice.actions

export const selectMenuError = (state) => {
  return state.menu.error
}

export default menuSlice.reducer
